/* Polsk katalog for locale-advisor-plan-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('pl', {
  'adv.plan.viewForecast': 'Zobacz prognozę',
  'adv.plan.forecastTitle': 'Przepływy pieniężne z zaplanowanymi zdarzeniami',
  'adv.plan.forecastIntro': 'Porównaj saldo oparte na zaksięgowanych danych z saldem po uwzględnieniu zdarzeń, które wprowadziłeś.',
  'adv.plan.forecastWithoutEvents': 'Bez zaplanowanych zdarzeń',
  'adv.plan.forecastWithEvents': 'Z zaplanowanymi zdarzeniami',
  'adv.plan.forecastChange': 'Zmiana na koniec roku',
  'adv.plan.forecastScope': 'Zaplanowane zdarzenia zmieniają tylko prognozę, a nie księgowość ani budżet. Saldo na wykresie zatrzymuje się na zerze, więc zmiana na koniec roku może być mniejsza niż suma zdarzeń.',
  'adv.plan.showVariance': 'Pokaż odchylenia',
  'adv.plan.hideVariance': 'Ukryj odchylenia',
});
